import axios from 'axios';

// Create a configured axios instance
const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
const client = axios.create({
    baseURL: baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to dynamically inject the Authorization header
client.interceptors.request.use(
    (config) => {
        if (typeof window !== 'undefined') {
            const pathname = window.location.pathname;
            let token = '';

            if (pathname.startsWith('/back-master')) {
                token = localStorage.getItem('master_token') || '';
            } else if (pathname.startsWith('/backstage')) {
                token = localStorage.getItem('seller_token') || '';
            } else {
                token = localStorage.getItem('buyer_token') || '';
            }

            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }

            if (config.method?.toLowerCase() === 'get') {
                config.headers['Cache-Control'] = 'no-cache';
                config.headers['Pragma'] = 'no-cache';
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 Unauthorized errors
client.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Skip redirection logic if this is a login request
            // Using a broader check for 'auth/login' and 'auth/kakao-login'
            const url = error.config?.url || '';
            const isLoginRequest = url.includes('auth/login') ||
                url.includes('auth/kakao-login');

            if (isLoginRequest) {
                console.log('401 error on login request - skipping redirection');
                return Promise.reject(error);
            }

            const pathname = window.location.pathname;

            if (pathname.startsWith('/back-master')) {
                localStorage.removeItem('master_token');
                window.location.href = '/back-master';
            } else if (pathname.startsWith('/backstage')) {
                localStorage.removeItem('seller_token');
                window.location.href = '/backstage';
            } else {
                localStorage.removeItem('buyer_token');
                // For buyers, we reload the current path to trigger the login view update in App.tsx
                window.location.reload();
            }
        }
        return Promise.reject(error);
    }
);

export default client;
